module.exports = __webpack_public_path__ + "static/adjustable-base-2-intro-gallery-17c740f45710eea04596f6d2a260fc35.mp4";